import styled from 'styled-components';

export default styled.label`
  display: flex;
  flex-direction: column;
  font-size: var(--regular);
  font-weight: var(--semi-bold);
  gap: 6px;
  justify-content: space-between;
  position: relative;
  color: var(--pleather);

  & + && {
    margin-top: 16px;
  }
`;
